<template>
  <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
    <v-toolbar dense :color="colorBarraFormulario" dark flat>
      <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
        <span v-bind:style="{ color: 'white' }">Punto</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon size="30" :color="'white'" @click="_cerrarVentana">mdi-close-circle</v-icon>
    </v-toolbar>
    <v-card-text>
      <v-row class="mt-6" dense>
        <v-col class="ml-0">
          <v-row dense class="mx-4">
            <v-text-field v-model="modelPunto.nombre" outlined label="Nombre" dense :dark="dark"
              autocomplete="off"></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-select outlined dense :dark="dark" autocomplete="off" v-model="modelPunto.provincia" label="Provincia"
              :items="provincias"></v-select>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field outlined dense :dark="dark" autocomplete="off" v-model="modelPunto.localizacion"
              placeholder="Coordenadas (latitud, longitud) Ej. 42.88443305902265, -8.527971575319986"
              label="Localizacion"></v-text-field>
          </v-row>

          <v-row dense class="mx-4 mb-4">
            <iframe class="mx-4"
              :src="'https://maps.google.com/maps?q=' + modelPunto.localizacion + '&z=12&output=embed'" width="840"
              height="200" style="border:0;" allowfullscreen="" loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"></iframe>
          </v-row>
          <v-row dense class="mx-4">
            <v-textarea outlined v-model="modelPunto.descripcion" :dark="dark" label="Descripcion"></v-textarea>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="mx-4 mb-2">
        <v-spacer></v-spacer>
        <v-chip class="mr-1 px-10" label :color="colorAccent1" text-color="white" link @click="_guardarPunto">
          <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
          <span v-else v-bind:style="{ color: 'white' }">Guardar</span>
        </v-chip>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";


export default {
  name: "PuntoFormulario",

  data: () => ({
    loading: false,
  }),

  props: {
    modelPunto: {
      type: Object,
      required: true,
    },

    accion: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState([
      "drawer",
      "dark",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
      "colorBarraFormulario",
      "colorFondoDialog",
      "provincias",

    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
  },


  mounted() {

  },

  methods: {
    ...mapActions("puntos", ["getPuntos", "crearPunto", "updatePunto"]),

    _cerrarVentana() {
      this.$emit("cerrarFormularioPunto");
    },

    async _guardarPunto() {
      this.loading = true;
      if (this.accion == "crear") {
        var res = await this.crearPunto([
          this.access_token,
          this.modelPunto,
        ]);
        const params = {};
        this._cerrarVentana();
        await this.getPuntos([this.access_token, false]);
      } else if (this.accion == "editar") {
        var res = await this.updatePunto([
          this.access_token,
          this.modelPunto,
        ]);
        this._cerrarVentana();
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.l-map {
  height: 100%;
  width: 100%;
}
</style>
